import React from 'react';
import Button from 'react-bootstrap/Button';
import AssignmentLateOutlinedIcon from '@material-ui/icons/AssignmentLateOutlined';

const EmptyOrdersLead = () => {
    return (
        <div className="page__lead--empty">
            <div className="empty--icon">
                <AssignmentLateOutlinedIcon />
            </div>
            <div className="empty--lead">
                <p>Do tej pory nie złożyłeś zamówień.</p>
                <p>Nie zwlekaj, czas na pierwsze zakupy!</p>
            </div>
            <div className="empty--actions">
                <Button
                    href={process.env.REACT_APP_SHOP}
                    variant="outline-secondary"
                    block
                    className="btn__default btn__white pl-4 pr-4"
                >
                    Rozpocznij zakupy
                </Button>
            </div>
        </div>
    );
};

export default EmptyOrdersLead;
